import {Mapper} from '@s-ui/domain'

export class FromNewsDetailInfoToBreadcrumbRequestValueObjectMapper extends Mapper {
  constructor({breadcrumbUrlBuilderRequestValueObject}) {
    super({breadcrumbUrlBuilderRequestValueObject})

    this._breadcrumbUrlBuilderRequestValueObject = breadcrumbUrlBuilderRequestValueObject
  }

  _getNewsBreadcrumbsPayload = newsDetailInfo => {
    const urlType = 'SearchNews'
    const {makeId, modelId} = newsDetailInfo

    const payload = {
      items: [
        {
          urlType,
          data: {}
        }
      ]
    }

    if (makeId) payload.items.push({urlType, data: {makeId}})
    if (modelId) payload.items.push({urlType, data: {makeId, modelId}})

    return payload
  }

  map = newsDetailInfo => {
    return this._breadcrumbUrlBuilderRequestValueObject(this._getNewsBreadcrumbsPayload(newsDetailInfo))
  }
}
